import React from 'react';
import './navigation.css';
// import { useHistory, Link } from 'react-router-dom';
import {Link, Element} from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStateValue } from '../../stateprovider';
import menuImg from '../../assets/menu.jpg'

export default function Navigation() {
    const [{ menu, navigation }, dispatch] = useStateValue()
    return <div className={(menu === true) ?'Navigation' : 'Navigation Navigation__Flex'}>
        <div className="Navigation__Webview">
            <div className='Navigation__Links Navigation__Disabled'>
               <a href="/"  onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'Home'
                    })
                }} className={(navigation === 'Home' ? 'Navigation__Active': 'Navigation__Disabled')}>Home</a>
                <a href="https://store.favdoctor.com" rel="noreferrer" onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'Store'
                    })
                }} className={(navigation === 'Store' ? 'Navigation__Active': 'Navigation__Disabled')}>Store</a>
                {navigation !== 'About' ?
                <Link to="service" activeClass='act' spy={true} smooth={true} offset={-70} duration={500} onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'services'
                    })
                }} className={(navigation === 'services' ? 'Navigation__Active': 'Navigation__Disabled')}>Our Services</Link>
                :
            <></>}
                <a href="/about"  onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'About'
                    })
                }} className={(navigation === 'About' ? 'Navigation__Active': 'Navigation__Disabled')}>About Us</a>
            </div>
            <div className='Navigation__Button'>
                <button><a href="https://favdoctor.com/article/blog" rel="noreferrer">Read a blog Post</a></button>
                <button><a href="/login" target="_self" rel="noreferrer" style={{ textDecoration: "none" }}>Log in</a></button>
            </div>
        </div>
        <div className={(menu === false) ? 'Navigation__Menu' : "notDisplay"}>
            {/*<FontAwesomeIcon icon="bars" onClick={() => {
                dispatch({
                    type: "MENU",
                    menu: true
                })
            }} className='menu' />*/}
           {/* <img src={menuImg} alt={menuImg}  onClick={() => {
                dispatch({
                    type: "MENU",
                    menu: true
                })
            }} className='menu' />*/}
            <div className='Navigation__Button'>
            <button><a href="/login" target="_self" rel="noreferrer" style={{ textDecoration: "none" }}>Log in</a></button>
        </div>
        </div>
       <div className={(menu === true) ? "Navigation__Mobile" : "notDisplay"}>
            <div className='Navigation__Links'>
            <a href="/"  onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'Home'
                    })
                    
                }} className={(navigation === 'Home' ? 'Navigation__Active': 'Navigation__Disabled')}>Home</a>
                <a href="https://store.favdoctor.com" rel="noreferrer" onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'Store'
                    })
                    dispatch({
                        type: "MENU",
                        menu: false
                    });
                }} className={(navigation === 'Store' ? 'Navigation__Active': 'Navigation__Disabled')}>Store</a>
               {navigation !== 'About' ? <Link to="service" activeClass='act' spy={true} smooth={true} offset={-70} duration={500} onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'services'
                    });
                    dispatch({
                        type: "MENU",
                        menu: false
                    });
                }} className={(navigation === 'services' ? 'Navigation__Active': 'Navigation__Disabled')}>Our Services</Link> : <></>}
                <a href="/about"  duration={500} onClick={()=>{
                    dispatch({
                        type:"ACTIVE_NAVIGAtION",
                        navigation: 'About'
                    })
                    dispatch({
                        type: "MENU",
                        menu: false
                    });
                }} className={(navigation === 'About' ? 'Navigation__Active': 'Navigation__Disabled')}>About Us</a> 
            </div>
            <div className='Navigation__Button' style={{ alignItems: "flex-end" }}>
            <button><a href="https://favdoctor.com/article/blog" rel="noreferrer">Read a blog Post</a></button>
            <button><a href="/user_signup_step_1"  style={{ textDecoration: "none" }}>Log in</a></button>
            </div>
            </div>

    </div>
}